import type { DisciplineScheduleGridSlot } from './interfaces'

import { useDisciplineScheduleStore } from './schedule/store'
import {
  formatScheduleBusyNotes,
  isScheduleSlotSelected,
  toggleScheduleSlot,
} from './discipline-schedule'

interface DisciplineScheduleSlotOptions {
  slot: ComputedRef<DisciplineScheduleGridSlot>
}

interface DisciplineScheduleSlotReturn {
  refIsSelected: ComputedRef<boolean>
  refIsDisabled: ComputedRef<boolean>
  refIsPartlyBusy: ComputedRef<boolean>
  refBusyNotes: ComputedRef<string>
  busyText: string
  toggleSlot: () => void
}

/** A fully busy hour stays clickable while it is selected, so the current schedule can be dropped. */
export const useDisciplineScheduleSlot = ({ slot }: DisciplineScheduleSlotOptions): DisciplineScheduleSlotReturn => {
  const store = useDisciplineScheduleStore()

  const refIsSelected = computed<boolean>(() => isScheduleSlotSelected(store.getSelected, slot.value))
  const refIsDisabled = computed<boolean>(() => slot.value.disabled && !refIsSelected.value)

  const refIsPartlyBusy = computed<boolean>(() =>
    slot.value.busy_slots.length > 0 && slot.value.busy_slots.length < store.getWeeksCount)

  const refBusyNotes = computed<string>(() => formatScheduleBusyNotes(slot.value.busy_slots, store.getWeeksCount))

  const toggleSlot = (): void => {
    if (refIsDisabled.value) return
    store.setSelected(toggleScheduleSlot(store.getSelected, slot.value))
  }

  return {
    refIsSelected,
    refIsDisabled,
    refIsPartlyBusy,
    refBusyNotes,
    busyText: 'Time slot is busy',
    toggleSlot,
  }
}
